import { jsxs as h, jsx as t } from "react/jsx-runtime";
import { Box as x, Pagination as s, Skeleton as I } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import "../../pointsGraph-DTJju-rA.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import { forms as R } from "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import _ from "@mui/icons-material/ArrowBack";
import a from "@mui/icons-material/ArrowForward";
import { useState as B, useEffect as P } from "react";
const rr = ({ studentId: c, formId: d, rowId: m, onChange: n }) => {
  const { isPending: f, data: r } = new R.RecordListStudent({ studentId: c, formId: d, includeExpired: 0 }).ToQuery(), [g, p] = B(0), l = (i, o) => {
    let e = r == null ? void 0 : r.Records.sort((u, w) => u._rowId - w._rowId)[o - 1]._rowId;
    e && n && n(e), p(o);
  };
  return P(() => {
    let i = r == null ? void 0 : r.Records.sort((o, e) => o._rowId - e._rowId).findIndex((o) => o._rowId == m);
    i != null && i != -1 && p(i + 1);
  }, [r == null ? void 0 : r.Records.length, m]), f ? /* @__PURE__ */ h(x, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
    /* @__PURE__ */ t(_, {}),
    /* @__PURE__ */ t(
      s,
      {
        count: 5,
        renderItem: () => /* @__PURE__ */ t(I, { sx: { marginLeft: 1, marginRight: 1 }, variant: "circular", width: 20, height: 20 })
      }
    ),
    /* @__PURE__ */ t(a, {})
  ] }) : /* @__PURE__ */ t(
    s,
    {
      count: r == null ? void 0 : r.Records.length,
      page: g,
      siblingCount: 0,
      showFirstButton: !0,
      showLastButton: !0,
      size: "small",
      onChange: l
    }
  );
};
export {
  rr as RecordPaging
};
//# sourceMappingURL=RecordPaging.js.map
